class AddToCart extends HTMLElement {
    constructor() {
        super();

        this.atcButton = this.querySelector('button');
        this._loading = false;
    }

    set loading(value) {
        this._loading = value;

        if (value) {
            this.atcButton.classList.add('is-loading');
            this.atcButton.disabled = true;
        } else {
            setTimeout(() => {
                this.atcButton.classList.remove('is-loading');
                this.atcButton.disabled = false;
            }, 1000);
        }
    }

    get loading() {
        return this._loading;
    }

    connectedCallback() {
        this.getUpdatedQuantity();

        this.atcButton.addEventListener('click', () => {
            if (this.getAttribute('data-main-product-id')) {
                const currentQuantity = this.getAttribute('data-main-current-quantity');
                const productId = this.getAttribute('data-main-product-id');
                this.addProductToCart(productId, currentQuantity);
            }
        });
    }

    getUpdatedQuantity() {
        document.addEventListener('product-quantity:adjusted', () => {
            const input = document.querySelector('main-quantity-adjust input');

            if (input) {
                this.setAttribute('data-main-current-quantity', input.value);
            }
        });
    }

    addProductToCart(productId, quantity) {
        this.loading = true;

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: productId,
                quantity: quantity
            })
        })
        .then(response => {
            if (!response.ok) throw new Error('Failed to add item to cart');
            return response.json();
        })
        .then(data => {
            this.loading = false;
            document.dispatchEvent(new CustomEvent('add-to-cart:product-added'));
        })
        .catch(error => {
            console.warn('Add to cart error:', error);
            this.loading = false;
        });
    }
}

if (!customElements.get('add-to-cart')) {
  customElements.define('add-to-cart', AddToCart);
}
